import { render, staticRenderFns } from "./BlogBlockForm.vue?vue&type=template&id=731232a2"
import script from "./BlogBlockForm.vue?vue&type=script&lang=js"
export * from "./BlogBlockForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports